import Cookies from 'js-cookie';

export default cookie => {
    let $electricityFormType = $('#electricity_formType').val();
    let $gasFormType = $('#gas_formType').val();

    // Electricity`
    let electricity = {
        formField: {
            zipCode: $('#electricity_plz'),
            paolaLocation: $('#electricity_paolaLocationId'),
            annualTotal: $('#electricity_annualTotal'),
        },
        cookieData: {
            zipCode: Cookies.get('sg-electricity-zip-code'),
            paolaLocation: Cookies.get('sg-electricity-paola-location'),
            annualTotal: Cookies.get('sg-electricity-annual-total'),
        }
    };

    // Gas
    let gas = {
        formField: {
            zipCode: $('#gas_plz'),
            paolaLocation: $('#gas_paolaLocationId'),
            annualTotal: $('#gas_annualTotal'),
        },
        cookieData: {
            zipCode: Cookies.get('sg-gas-zip-code'),
            paolaLocation: Cookies.get('sg-gas-paola-location'),
            annualTotal: Cookies.get('sg-gas-annual-total'),
        }
    };

    if ($electricityFormType === 'small') {
        let triggerEvent = false;
        $.each(electricity.cookieData, function(index, value) {
            if (typeof value !== 'undefined' && typeof electricity.formField[index] !== 'undefined') {
                electricity.formField[index].val(value);
                triggerEvent = true;
            }
        });

        if (triggerEvent) {
            $.event.trigger('electricity_loadNewPaolaLocationIds');
            $.event.trigger('cookieDataLoad');
        }
    }

    // Use only on small forms and use php session on full form
    if ($gasFormType === 'small') {
        let triggerEvent = false;
        $.each(gas.cookieData, function (index, value) {
            if (typeof value !== 'undefined' && typeof gas.formField[index] !== 'undefined') {
                gas.formField[index].val(value);
                triggerEvent = true;
            }
        });

        if (triggerEvent) {
            $.event.trigger('gas_loadNewPaolaLocationIds');
            $.event.trigger('cookieDataLoad');
        }
    }

    $(document).on('electricity_paolaLocationReload gas_paolaLocationReload', event => {
        switch (event.form) {
            // Nur übernehmen, wenn es den gespeicherten Stadtteil für die neue PLZ auch gibt
            case "electricity":
                if (typeof electricity.cookieData.paolaLocation !== 'undefined'
                    && electricity.formField.paolaLocation.find(`option[value="${electricity.cookieData.paolaLocation}"]`).length > 0
                ) {
                    electricity.formField.paolaLocation.val(electricity.cookieData.paolaLocation);
                }
                break;
            case "gas":
                if (typeof gas.cookieData.paolaLocation !== 'undefined'
                    && gas.formField.paolaLocation.find(`option[value="${gas.cookieData.paolaLocation}"]`).length > 0
                ) {
                    gas.formField.paolaLocation.val(gas.cookieData.paolaLocation);
                }
                break;
        }
    });

    // Save last entered from data in cookie
    $(document).on('electricity_zipCodeChanged gas_zipCodeChanged ' +
                   'electricity_paolaLocationChanged gas_paolaLocationChanged ' +
                   'electricity_annualTotalChanged gas_annualTotalChanged', event => {

        switch(event.type) {
            case "electricity_zipCodeChanged":
                Cookies.set(`sg-electricity-zip-code`, event.zipCode, {expires: 30, path: '/'});
                break;
            case "gas_zipCodeChanged":
                Cookies.set(`sg-gas-zip-code`, event.zipCode, {expires: 30, path: '/'});
                break;
            case "electricity_paolaLocationChanged":
                Cookies.set(`sg-electricity-paola-location`, event.paolaLocationId, {expires: 30, path: '/'});
                break;
            case "gas_paolaLocationChanged":
                Cookies.set(`sg-gas-paola-location`, event.paolaLocationId, {expires: 30, path: '/'});
                break;
            case "electricity_annualTotalChanged":
                Cookies.set(`sg-electricity-annual-total`, event.annualTotal, {expires: 30, path: '/'});
                break;
            case "gas_annualTotalChanged":
                Cookies.set(`sg-gas-annual-total`, event.annualTotal, {expires: 30, path: '/'});
                break;
        }
    });
};
